import React, { useEffect, useState } from "react";

// Airtable constants from constants.js
import { AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "../constants";

export default function TechnicianList() {
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedIds, setExpandedIds] = useState([]); // 👈 New toggle state

  useEffect(() => {
    fetchTechnicians();
  }, []);

 const fetchTechnicians = async () => {
  try {
    const res = await fetch(AIRTABLE_URL_TECHNICIAN, {
      headers: AIRTABLE_HEADERS,
    });

      const data = await res.json();

  const cleaned = data.records.filter((rec) => {
  const f = rec.fields;
  const isPending = f.status?.toLowerCase() === "pending";
  const isDutyOn = f.duty?.toLowerCase() === "on";

  return (
    (isPending || isDutyOn) &&
    f.name &&
    f.phone &&
    f.address &&
    f.name.trim() !== "" &&
    f.phone.trim() !== "" &&
    f.address.trim() !== ""
  );
});


      setTechnicians(cleaned);
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const updateStatus = async (recordId, newStatus) => {
  try {
    const response = await fetch(`${AIRTABLE_URL_TECHNICIAN}/${recordId}`, {
      method: "PATCH",
      headers: AIRTABLE_HEADERS,
      body: JSON.stringify({
        fields: {
          status: newStatus,

  ...(newStatus === "reject" && { duty: "off" }) // ✅ only include duty if rejecting
},
      }),
    });

    if (!response.ok) throw new Error("Failed to update status");

    alert(`Status updated to "${newStatus}"`);
    // optionally reload or refetch here
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update status");
  }
};


  const toggleExpand = (id) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>👨‍🔧 Technician List</h2>

      {loading ? (
        <p>Loading technicians...</p>
      ) : technicians.length === 0 ? (
        <p>No technician data found.</p>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          {technicians.map((tech, index) => {
            const expanded = expandedIds.includes(tech.id);
            const { name, phone, duty } = tech.fields;

            return (
              <div
                key={index}
                style={{
                  border: "1px solid #ccc",
                  borderRadius: 6,
                  padding: 15,
                  background: "#f9f9f9",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <div>
    <div><b>{name}</b></div>
    <div> {phone}</div>
    <div>
      Duty: {duty || "N/A"} | Status:{" "}
      <span style={{  }}>
        {tech.fields.status || "Not Set"}
      </span>
    </div>
  </div>

  <button
    onClick={() => toggleExpand(tech.id)}
    style={{
      background: "#007bff",
      color: "#fff",
      border: "none",
      padding: "4px 10px",
      borderRadius: 4,
      cursor: "pointer"
    }}
  >
    {expanded ? "Hide ▲" : "View ▼"}
  </button>
</div>
                {expanded && (
                  <>
                    <p><b>Date of Birth:</b> {tech.fields.dateofbirh}</p>
                    <p><b>Address:</b> {tech.fields.address}</p>
                    <p><b>Pincode:</b> {tech.fields.pincode}</p>
                    <p><b>Aadhaar:</b> {tech.fields.aadhaar}</p>
                    <p><b>PAN:</b> {tech.fields.pan}</p>
                    <p><b>Bank Name:</b> {tech.fields.bankName}</p>
                    <p><b>Account Number:</b> {tech.fields.accountNumber}</p>
                    <p><b>IFSC:</b> {tech.fields.ifsc}</p>
                    <p><b>Password:</b> {tech.fields.password}</p>
                    <p><b>Status:</b> {tech.fields.status || "Not Set"}</p>
                    <p><b>Timestamp:</b> {tech.fields.timestamp}</p>

                    <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                      {tech.fields.profilePhoto && (
                        <img src={tech.fields.profilePhoto} alt="Profile" width="80" style={{ borderRadius: 4 }} />
                      )}
                      {tech.fields.aadhaarPhoto && (
                        <img src={tech.fields.aadhaarPhoto} alt="Aadhaar" width="80" style={{ borderRadius: 4 }} />
                      )}
                      {tech.fields.panPhoto && (
                        <img src={tech.fields.panPhoto} alt="PAN" width="80" style={{ borderRadius: 4 }} />
                      )}
                    </div>

                    <div style={{ marginTop: 10 }}>
                      <button
                        onClick={() => updateStatus(tech.id, "approve")}
                        style={{
                          marginRight: 10,
                          backgroundColor: "#28a745",
                          color: "#fff",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: 4,
                          cursor: "pointer",
                        }}
                      >
                        Approve ✅
                      </button>
                      <button
                        onClick={() => updateStatus(tech.id, "reject")}
                        style={{
                          backgroundColor: "#dc3545",
                          color: "#fff",
                          border: "none",
                          padding: "6px 12px",
                          borderRadius: 4,
                          cursor: "pointer",
                        }}
                      >
                        Reject ❌
                      </button>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
